import { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Skeleton,
} from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { SiteBurndownChart } from '../../sites/components/SiteBurndownChart';
import { useSitesSummary } from '../../sites/hooks/useSitesSummary';

export function DashboardSiteBurndown() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { data: sites, isLoading } = useSitesSummary();

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  if (!sites || sites.length === 0) {
    return (
      <Card data-testid="dashboard-site-burndown">
        <CardContent sx={{ p: 3 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 200,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              No sites available
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  const currentSite = sites[selectedIndex];

  return (
    <Card data-testid="dashboard-site-burndown">
      <CardContent sx={{ p: 3 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <IconButton
            data-testid="dashboard-site-burndown-prev"
            disabled={selectedIndex === 0}
            onClick={() => setSelectedIndex(i => i - 1)}
            size="small"
          >
            <ChevronLeft />
          </IconButton>
          <Typography variant="subtitle1" fontWeight={700} sx={{ mx: 1 }}>
            {currentSite.name}
          </Typography>
          <IconButton
            data-testid="dashboard-site-burndown-next"
            disabled={selectedIndex === sites.length - 1}
            onClick={() => setSelectedIndex(i => i + 1)}
            size="small"
          >
            <ChevronRight />
          </IconButton>
        </Box>
        <SiteBurndownChart siteId={currentSite.id} />
      </CardContent>
    </Card>
  );
}

function LoadingSkeleton() {
  return (
    <Card data-testid="dashboard-site-burndown-loading">
      <CardContent sx={{ p: 3 }}>
        <Skeleton width={200} height={24} sx={{ mb: 0.5 }} />
        <Skeleton width={120} height={18} sx={{ mb: 3 }} />
        <Skeleton variant="rectangular" height={300} sx={{ borderRadius: 1 }} />
      </CardContent>
    </Card>
  );
}
